// if you're using a bundler, first import:
import Headroom from "headroom.js";

const HeaderScroll = () => {
    // Find the header element
    const header = document.querySelector("header");
    const headerButton = document.querySelector('.header__mobile');
    const body = document.querySelector('body');

    if (!header) return;

    // Mobile menu toggle
    if (headerButton) {
        headerButton.addEventListener('click', () => {
            body.classList.toggle('no-scroll');
        });
    }

    // Check if we're on a single program page
    const isProgramPage = body.classList.contains('single-program');

    let headroomOptions = {};

    if (isProgramPage) {
        // Option 3: Only reappear when scrolled all the way back to the top
        headroomOptions = {
            onPin: function() {
                // If we're not near the top, keep it hidden
                if (window.scrollY > 100) {
                    this.elem.classList.remove('headroom--pinned');
                    this.elem.classList.add('headroom--unpinned');
                }
            }
        };
    }

    // Initialise Headroom with the appropriate options
    const headroom = new Headroom(header, headroomOptions);
    headroom.init();
};

export default HeaderScroll;
